import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=1f3874d4&scoped=true"
import script from "./ContentEdit.vue?vue&type=script&lang=js"
export * from "./ContentEdit.vue?vue&type=script&lang=js"
import style0 from "./ContentEdit.vue?vue&type=style&index=0&id=1f3874d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3874d4",
  null
  
)

export default component.exports